const RESPONSE_CHANGE_SELECTED_CAR = 'RESPONSE_CHANGE_SELECTED_CAR'
const CLEAR_SELECTED_CARS = 'CLEAR_SELECTED_CARS'

const changeSelectedCarAction = (data) => {
  return {
    type: RESPONSE_CHANGE_SELECTED_CAR,
    data,
  }
}

const changeSelectedCar = (data) => {
  return (dispatch) => {
    dispatch(changeSelectedCarAction(data))
  }
}

const clearSelectedCarsAction = () => {
  return {
    type: CLEAR_SELECTED_CARS
  }
}

export {
  RESPONSE_CHANGE_SELECTED_CAR,
  changeSelectedCarAction,
  changeSelectedCar,

  CLEAR_SELECTED_CARS,
  clearSelectedCarsAction
}
